import React from 'react';

// Inline icons that mirror the REAL UI, so guide text can point at the exact glyph
// a user sees on screen (rather than describing it in words). Sized to sit with
// body text via .kb-ico in global.css. Keep these copies in step with the source
// components if those glyphs ever change (ColumnsIcon in CaseList, star/chevron in
// SavedViews).

// The All Cases column chooser (Marius's table-with-plus; the plus strokes teal).
export function ColumnsGlyph() {
  return (
    <svg className="kb-ico" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <path d="M21.187 5.99805C20.9854 5.10929 20.6539 4.43424 20.1089 3.88929C18.7177 2.49805 16.4785 2.49805 12.0002 2.49805C7.52184 2.49805 5.28267 2.49805 3.89143 3.88929C2.50018 5.28053 2.50018 7.5197 2.50018 11.998C2.50018 16.4764 2.50018 18.7156 3.89143 20.1068C5.28267 21.498 7.52184 21.498 12.0002 21.498C16.4785 21.498 18.7177 21.498 20.1089 20.1068C20.6539 19.5619 20.9854 18.8868 21.187 17.998" />
      <path d="M9 21.5L9 2.5" />
      <path d="M2.5 15.5L9 15.5M2.5 8.5L9 8.5" />
      <path d="M21.5 12L17.5 12M17.5 12H13.5M17.5 12V16M17.5 12L17.5 8" stroke="var(--brand)" strokeWidth="1.9" />
    </svg>
  );
}

// The "save this view" star (amber, so it reads as the star it names).
export function StarGlyph() {
  return (
    <svg className="kb-ico kb-ico-star" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
    </svg>
  );
}

// The saved-views dropdown chevron.
export function ChevronGlyph() {
  return (
    <svg className="kb-ico" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <polyline points="6 9 12 15 18 9" />
    </svg>
  );
}
